import { Tombstone } from "../types/events";

/** Reads the tombstones a document stores as JSON in its TOMBSTONES internal attribute. */
export function parseTombstones(json: unknown): Tombstone[] {
  if (typeof json !== "string") return [];
  try {
    const parsed: unknown = JSON.parse(json);
    return Array.isArray(parsed) ? (parsed as Tombstone[]) : [];
  } catch {
    return [];
  }
}
